export * from './moh-contract-setup.component';
